

















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { WordSearchPuzzle, Cell } from '@/wordsearch/types';

const puzzle = namespace('Puzzle');

@Component
export default class PrintPuzzleGrid extends Vue {
  @puzzle.State
  public puzzle!: WordSearchPuzzle;

  @puzzle.State
  private gridSize!: number;

  @puzzle.Getter
  private cellWidth!: number;

  @puzzle.Getter
  private cellHeight!: number;

  private getStyleForCell(cell: Cell): string {
    return `
      left: ${this.cellWidth * cell.x}px;
      top: ${this.cellHeight * cell.y}px;
      width: ${this.cellWidth}px;
      height: ${this.cellHeight}px;
      line-height: ${this.cellHeight}px;
    `;
  }

  get gridStyle() {
    return `
      width: ${this.gridSize}px;
      height: ${this.gridSize}px;
      min-width: ${this.gridSize}px;
    `;
  }
}
